export default __webpack_public_path__ + "static/media/Mark-6-HUD-Header.7b8b6a38.jpg";